import $ from 'jquery';
import { getStatePure, modifyState, getState } from '~src/state';
import { addPagesToSidebar } from '~src/multipages';
import { saveEditorPagesOrder } from './saveEditorPagesOrder';

export const handleMovePageUp = async (event) => {
  event.preventDefault();
  // Don't stop propagation - let the global handler close the menu

  const pageIndex = parseInt($(event.currentTarget).data('page-move-up'));
  const pages = getStatePure('pages');
  const currentPageIndex = getState('currentPageIndex');

  if (pageIndex <= 0 || pageIndex >= pages.length) {
    return;
  }

  // Swap pages
  const pagesCopy = [...pages];
  const temp = pagesCopy[pageIndex];
  pagesCopy[pageIndex] = pagesCopy[pageIndex - 1];
  pagesCopy[pageIndex - 1] = temp;

  // Update state
  await modifyState('pages', pagesCopy);

  // Update current page index if needed
  if (currentPageIndex === pageIndex) {
    await modifyState('currentPageIndex', pageIndex - 1);
  } else if (currentPageIndex === pageIndex - 1) {
    await modifyState('currentPageIndex', pageIndex);
  }

  // Save order to backend
  await saveEditorPagesOrder(window.editorLoader.canvasId, pagesCopy);

  // Refresh sidebar
  await addPagesToSidebar();
};

export const handleMovePageDown = async (event) => {
  event.preventDefault();
  // Don't stop propagation - let the global handler close the menu

  const pageIndex = parseInt($(event.currentTarget).data('page-move-down'));
  const pages = getStatePure('pages');
  const currentPageIndex = getState('currentPageIndex');

  if (pageIndex < 0 || pageIndex >= pages.length - 1) {
    return;
  }

  // Swap pages
  const pagesCopy = [...pages];
  const temp = pagesCopy[pageIndex];
  pagesCopy[pageIndex] = pagesCopy[pageIndex + 1];
  pagesCopy[pageIndex + 1] = temp;

  // Update state
  await modifyState('pages', pagesCopy);

  // Update current page index if needed
  if (currentPageIndex === pageIndex) {
    await modifyState('currentPageIndex', pageIndex + 1);
  } else if (currentPageIndex === pageIndex + 1) {
    await modifyState('currentPageIndex', pageIndex);
  }

  // Save order to backend
  await saveEditorPagesOrder(window.editorLoader.canvasId, pagesCopy);

  // Refresh sidebar
  await addPagesToSidebar();
};
